import DOMPurify from 'dompurify';

export const sanitizeHtmlContent = (htmlContent) => {
  const sanitizedHtml = DOMPurify.sanitize(htmlContent);
  return { __html: sanitizedHtml };
};
